import * as T from "@shared/types";
import { axios } from ".";

const BATCHES_BASE_URL = "/api/v1/batches/bc-batches";

export const getLabelPrintBatches = async (params: T.LabelPrintBatchSummaryRequest) => {
  const url = `${BATCHES_BASE_URL}/summary`;
  const response = await axios.get<T.LabelPrintBatchesFetchResult>(url, { params });
  return response.data;
};

export const getLabelPrintBatchById = async (batchId: string) => {
  const url = `${BATCHES_BASE_URL}/${batchId}`;
  const response = await axios.get<T.LabelPrintBatchFetchResult>(url);
  return response.data;
};

export const createLabelPrintBatch = async (batch: T.LabelPrintBatchCreateRequest) => {
  const response = await axios.post<T.LabelPrintBatchCreateResult>(`${BATCHES_BASE_URL}/shipping-documents`, batch);
  return response.data;
};

export const createLabelPrintBatchManifest = async (batchId: string) => {
  const url = `${BATCHES_BASE_URL}/${batchId}/manifest`;
  const response = await axios.post<{ data: string }>(url);
  return response.data;
};

export const getLabelPrintBatchShippingDocument = async (batchId: string, type: T.LabelPrintBatchFileType) => {
  const url = `${BATCHES_BASE_URL}/${batchId}/shipping-document?type=${type}`;
  const response = await axios.get<{ data: string }>(url);
  return response.data;
};
